import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { FaEdit, FaTrash } from 'react-icons/fa';
import config from "../../../config/config";
import { getAuthToken } from "../../../utils/token";
import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../loader/Loader';
import Select from "react-select";
const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#0d6efd',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '14px',
    },
  },
};

export default function Die() {
  const [dataList, setDataList] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [listLoading, setListLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [machineList, setMachineList] = useState([])
  const initialState = {
    name: '',
    code: '',
    type: '',
    machine_id: '',
    usage_count: '',
    max_cycles: '',
    max_cycles_per_day: '',
    max_cycles_per_month: '',
    max_cycles_per_year: '',
    purchase_date: '',
    last_service_date: '',
    next_service_date: '',
    expiry_date: ''
  };
  const [form, setForm] = useState(initialState);
  useEffect(() => {
    fetchList();
    fetchMachineList()
  }, []);
  const fetchList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/admin/lisdie`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDataList(res.data.dies || []);
    } catch (err) {
      console.error("Error fetching die list:", err);
      toast.error("Failed to load data");
    } finally {
      setListLoading(false);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: null }));
  };
  const openAddModal = () => {
    setForm(initialState);
    setErrors({});
    setIsEditing(false);
    setEditingId(null);
    setShowModal(true);
  };
  const openEditModal = (item) => {
    setForm({ ...item });
    setErrors({});
    setIsEditing(true);
    setEditingId(item.id);
    setShowModal(true);
  };
  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication missing");
      return;
    }
    setErrors({});
    const payload = {
      name: form.name,
      code: form.code,
      type: form.type,
      machine_id: Number(form.machine_id),
      usage_count: Number(form.usage_count),
      max_cycles: Number(form.max_cycles),
      max_cycles_per_day: Number(form.max_cycles_per_day),
      max_cycles_per_month: Number(form.max_cycles_per_month),
      max_cycles_per_year: Number(form.max_cycles_per_year),
      purchase_date: form.purchase_date,
      last_service_date: form.last_service_date,
      next_service_date: form.next_service_date,
      expiry_date: form.expiry_date
    };

    setFormLoading(true);
    try {
      if (isEditing && editingId) {
        await axios.put(`${config.API}/admin/updatedie/${editingId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success("Updated successfully");
      } else {
        await axios.post(`${config.API}/admin/adddie`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success("Created successfully");
      }
      setShowModal(false);
      fetchList();
    } catch (err) {
      if (err.response?.status === 422) {
        const data = err.response.data;
        if (data.errors) {
          setErrors(data.errors); 
        } else if (data.message) {
          toast.error(data.message); 
        }
      } else {
        console.error("Submit error:", err);
        toast.error("Submit failed! Please try again.");
      }
    } finally {
      setFormLoading(false);
    }
  };
  const renderError = (field) => errors[field] ? <div className="text-danger small">{errors[field][0]}</div> : null;
  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true },
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Code', selector: row => row.code, sortable: true },
    { name: 'Type', selector: row => row.type, sortable: true },
    { name: 'Machine ID', selector: row => row?.machine?.name, sortable: true },
    { name: 'Usage Count', selector: row => row.usage_count, sortable: true },
    { name: 'Max Cycles', selector: row => row.max_cycles, sortable: true },
    { name: 'Max/Day', selector: row => row.max_cycles_per_day, sortable: true },
    { name: 'Max/Month', selector: row => row.max_cycles_per_month, sortable: true },
    { name: 'Max/Year', selector: row => row.max_cycles_per_year, sortable: true },
    { name: 'Purchase Date', selector: row => row.purchase_date, sortable: true },
    { name: 'Last Service', selector: row => row.last_service_date, sortable: true },
    { name: 'Next Service', selector: row => row.next_service_date, sortable: true },
    { name: 'Expiry Date', selector: row => row.expiry_date, sortable: true },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-2">
          <button className="btn btn-sm btn-primary" onClick={() => openEditModal(row)}><FaEdit /></button>
          <button className="btn btn-sm btn-danger"><FaTrash /></button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];

  const fetchMachineList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/machine/list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMachineList(res.data.machines || []);
    } catch (err) {
      console.error("fetchMachineList:", err);
      toast.error("Failed to load data");
    } finally {
      setListLoading(false);
    }
  };
  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong className="mb-0 fs-4">Die Details</strong>
        <div>
          <input
            type="text"
            className="form-control d-inline-block me-2"
            placeholder="Search..."
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            style={{ width: '200px' }}
          />
          <button className="btn btn-primary" onClick={openAddModal}>+ Add Die</button>
        </div>
      </div>

      {listLoading ? (
        <div className="text-center"><Loader /></div>
      ) : (
        <DataTable
          columns={columns}
          data={dataList.filter(item =>
            Object.values(item).join(' ').toLowerCase().includes(filterText.toLowerCase())
          )}
          pagination
          highlightOnHover
          customStyles={customStyles}
        />
      )}

      {showModal && (
        <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-primary text-light">
                <h5>{isEditing ? 'Edit Die' : 'Add Die'}</h5>
                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)} />
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Name</label>
                    <input type="text" name="name" className="form-control"
                      value={form.name} onChange={handleInput} disabled={formLoading} />
                    {renderError("name")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Code</label>
                    <input type="text" name="code" className="form-control"
                      value={form.code} onChange={handleInput} disabled={formLoading} />
                    {renderError("code")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Type</label>
                    <input type="text" name="type" className="form-control"
                      value={form.type} onChange={handleInput} disabled={formLoading} />
                    {renderError("type")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Machine</label>
                    <Select
                      name="machine_id"
                      value={
                        machineList
                          .map((m) => ({ value: m.id, label: m.machine_code }))
                          .find((option) => option.value === form.machine_id) || null
                      }
                      onChange={(selectedOption) =>
                        setForm((prev) => ({
                          ...prev,
                          machine_id: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      options={machineList.map((m) => ({
                        value: m.id,
                        label: m.machine_code,
                      }))}
                      isDisabled={formLoading || listLoading}
                      placeholder="-- Select Machine --"
                      isSearchable
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.machine_id ? "red" : base.borderColor,
                        }),
                      }}
                    />
                    {renderError("machine_id")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Usage Count</label>
                    <input type="number" name="usage_count" className="form-control"
                      value={form.usage_count} onChange={handleInput} disabled={formLoading} />
                    {renderError("usage_count")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Max Cycles</label>
                    <input type="number" name="max_cycles" className="form-control"
                      value={form.max_cycles} onChange={handleInput} disabled={formLoading} />
                    {renderError("max_cycles")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Max Cycles Per Day</label>
                    <input type="number" name="max_cycles_per_day" className="form-control"
                      value={form.max_cycles_per_day} onChange={handleInput} disabled={formLoading} />
                    {renderError("max_cycles_per_day")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Max Cycles Per Month</label>
                    <input type="number" name="max_cycles_per_month" className="form-control"
                      value={form.max_cycles_per_month} onChange={handleInput} disabled={formLoading} />
                    {renderError("max_cycles_per_month")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Max Cycles Per Year</label>
                    <input type="number" name="max_cycles_per_year" className="form-control"
                      value={form.max_cycles_per_year} onChange={handleInput} disabled={formLoading} />
                    {renderError("max_cycles_per_year")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Purchase Date</label>
                    <input type="date" name="purchase_date" className="form-control"
                      value={form.purchase_date} onChange={handleInput} disabled={formLoading} />
                    {renderError("purchase_date")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Last Service Date</label>
                    <input type="date" name="last_service_date" className="form-control"
                      value={form.last_service_date} onChange={handleInput} disabled={formLoading} />
                    {renderError("last_service_date")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Next Service Date</label>
                    <input type="date" name="next_service_date" className="form-control"
                      value={form.next_service_date} onChange={handleInput} disabled={formLoading} />
                    {renderError("next_service_date")}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Expiry Date</label>
                    <input type="date" name="expiry_date" className="form-control"
                      value={form.expiry_date} onChange={handleInput} disabled={formLoading} />
                    {renderError("expiry_date")}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)} disabled={formLoading}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={formLoading}>
                  {formLoading ? 'Saving...' : isEditing ? 'Update' : 'Save'}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}
